<template>
  <div>
    <item-write-link v-for="writeLayout in writeLayouts" :key="`itemComp${writeLayout}`"
                     :writeLayout="writeLayout"
                     :itemCategoryList="itemCategoryList"></item-write-link>
  </div>
</template>

<script>
import ItemWriteLink from "@/components/item/ItemWriteLink";
import itemUtil from "@/components/item/itemUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import itemValidator from "@/mixins/validators/itemValidator";
import exifMixins from "@/components/item/lib/exifMixins";
import exifr from 'exifr'
import dateMixins from "@/mixins/dateMixins";
import eventBus from "@/utils/event-bus";

export default {
  name: "ItemWriteAutoComponent",
  mixins: [itemUtil, alertMixins, awsS3FileUpload, itemValidator, exifMixins, dateMixins],
  components: {ItemWriteLink},
  provide() {
    return {
      itemWriteSetData: this.setData
    }
  },
  inject: ['changeLoading'],
  props: {
    itemType: {default: ''},
  },
  data() {
    return {
      writeLayouts: [],
      writeFunc: '',
      writeApiParamSet: {},
      parsingData: {},
      fileInfo: [],
      directUrl: '',
      directType: '',
      keyName: '',
      writeSuccessType: '',
      writeFailTypes: {},
      itemCategoryList: [],
      exif: {},
      test: {},
      writeValidatorArr: [],
      errorNum: 0
    }
  },
  created() {
    this.getItemCategory()
    this.initConfig();
  },
  mounted() {
    EventBus.$on('itemAutoWrite', this.checkValidator)
  },
  beforeDestroy() {
    EventBus.$off('itemAutoWrite')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(type, value) {
      this[type] = value;
    },
    initConfig() {
      let configItem = this.returnItemConfig(this.itemType);
      this.writeLayouts = configItem.writeLayouts;
      this.getFunc = configItem.getFunc;
      this.detailApiParamSet = configItem.detailApiParamsSet
      this.writeFunc = configItem.writeFunc;
      this.writeApiParamSet = configItem.writeApiParamSet;
      this.parsingData = configItem.parsingData;
      this.fileInfo = configItem.fileInfo;
      this.directUrl = configItem.directUrl;
      this.directType = configItem.directType;
      this.writeSuccessType = configItem.writeSuccessType;
      this.keyName = configItem.keyName;
      this.writeFailTypes = configItem.writeFailTypes;
      this.writeValidatorArr = configItem.writeValidatorArr;
      this.afterType = configItem.afterType;
      this.successMsg = configItem.successMsg;
    },
    getItemCategory() {
      let params = {}
      this.$api.$item.getItemCategory(params).then(res => res.Data.Result).then(res => {
        if (res.Info.type != 1) {
          return false;
        }
        this.itemCategoryList = res.List
      })
    },
    checkValidator() {
      let validatorArr = this.writeValidatorArr;
      this.$validate(validatorArr).then(success => {
        if (success) {
          this.makeParams(0);
        } else {
          util.Array.each(this.writeLayouts, (layout, index, arr) => {
            EventBus.$emit(`${layout}Validator`, validatorArr);
          })
        }
      })
    },
    writeItem(obj) {
      if (this.exif.hasOwnProperty('create') && !util.isEmpty(this.exif.create) && this.exif.create !== 0) {
        let itemDate = this.returnDateFormat(Date(this.exif.create), 'YYYY-MM-DD HH:mm:ss');
        obj.params.imo_date = itemDate
      }
      if (this.exif.hasOwnProperty('country')) {
        obj.params.imo_country = this.exif.country
      }
      if (this.exif.hasOwnProperty('si')) {
        obj.params.imo_si = this.exif.si
      }
      if (this.exif.hasOwnProperty('city')) {
        obj.params.imo_city = this.exif.city
      }
      if (this.exif.hasOwnProperty('size')) {
        obj.params.imo_size = this.exif.size
      }
      if (this.exif.hasOwnProperty('copyright')) {
        obj.params.imo_copyright = this.exif.copyright
      }
      if (this.exif.hasOwnProperty('hash')) {
        obj.params.hash = this.exif.hash
      }
      if (this.exif.hasOwnProperty('title') && !util.isEmpty(this.exif.title)) {
        obj.params.i_name = this.exif.copyright
      }

      this.thumbnailFile = [this.files[obj.index]];
      this.originalFile = [this.files[obj.index]];
      this.$api.$item[this.writeFunc](obj.params).then(res => res.Data.Result).then(res => {
        if (!res.List.Data.Status) {
          this.errorNum += 1;
          if (this.files.length - 1 > obj.index) {
            this.makeParams(obj.index + 1);
          } else {
            this.writeAfterFunc();
          }
          return false;
        }
        this.itemIdx = res.List.Data.Data.Basic.Data.Item.Data.i_idx;
        this.setMultiFileUpload(this.itemIdx, this.fileInfo, obj.index)
      });
    },
    async makeParams(index = 0) {
      let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
      let dataArr = Object.keys(this.parsingData);
      dataArr.forEach(dataKey => {
        params[this.parsingData[dataKey]] = this[dataKey];
      })
      params.i_name = this.files[index].org_name
      params.mb_no = this.selectMember.key
      this.makeExifData({ 'file' : this.files[index] , 'params' : params, 'index' : index})
    },
    makeExifData(obj) {
      let _this = this;
      let fileData = obj.file.raw;
      let url = obj.file.org_url;
      let exifData = {};
      exifr.parse(fileData, true).then(res => {
        exifData = res;
        exifData.fileUrl = url;
        _this.test = res;
        _this.exif = _this.setExifFormat()
        _this._settingExifValue(exifData,obj)
        _this.$forceUpdate();
      });

    },
    setExifFormat() {
      let exif = {
        create: '',
        country: '',
        si: '',
        city: '',
        size: '',
        copyright: '',
        title: '',
        hash: '',
      }
      return exif
    },
    async _settingExifValue(exifData,obj) {
      await this._settingImageExifValueCreate(exifData);
      await this._settingImageExifValueLocation(exifData);
      await this._settingImageExifValueSize(exifData);
      await this._settingImageExifValueCopyright(exifData);
      await this._settingTitleExifValueTitle(exifData);
      await this._settingTitleExifValueTag(exifData);
      await this.writeItem(obj);
    },

    async _settingImageExifValueCreate(exifData) {
      let create = await this.getExifDataCreate(exifData)
      if (!util.isEmpty(create)) {
        this.exif.create = create;
      }
    },
    async _settingImageExifValueLocation(exifData) {
      let location = await this.getExifDataImageLocation(exifData)
      if (!util.isEmpty(location.country)) {
        this.exif.country = location.country;
      }
      if (!util.isEmpty(location.si)) {
        this.exif.si = location.si;
      }
      if (!util.isEmpty(location.city)) {
        this.exif.city = location.city;
      }
    },
    async _settingImageExifValueSize(exifData) {
      let size = await this.getImageExifDataSize(exifData, exifData.fileUrl);
      if (!util.isEmpty(size)) {
        this.exif.size = size;
      }
    },
    async _settingImageExifValueCopyright(exifData) {
      let copyright = await this.getExifDataCopyright(exifData);
      if (!util.isEmpty(copyright)) {
        this.exif.copyright = copyright;
      }
    },
    async _settingTitleExifValueTitle(exifData) {
      let title = await this.getExifDataTitle(exifData)
      if (!util.isEmpty(title)) {
        this.exif.title = title
      }
    },
    async _settingTitleExifValueTag(exifData) {
      let tag = await this.getExifDataTag(exifData)
      let hash = [];
      if (!util.isEmpty(tag)) {
        util.Array.each(tag, (data, index, arr) => {
          hash.push({type: 2, tag: data})
          this.exif.hash = hash;
        });
      }
    },

    setMultiFileUpload(key, fileInfo, index) {
      this.runUploadFileInfo(fileInfo, 0, key).then(res => {
        this.addHash(key, index)
      })
    },
    addHash(key, index) {
      EventBus.$emit('apiLoading', true);
      let params = {
        i_idx: key
      }
      this.$api.$item.addHash(params).then(res => res.Data.Result).then(res => {
        if (res.Info.type !== 1) {
          this.errorNum += 1;
          if (this.files.length - 1 > index) {
            this.makeParams(index + 1);
          } else {
            this.writeAfterFunc();
          }
        } else {
          if (this.files.length - 1 > index) {
            this.makeParams(index + 1);
          } else {
            this.writeAfterFunc();
          }
        }
      })
    },
    writeAfterFunc() {
      let total = this.files.length
      let msg = `총 ${total} 중 ${total - this.errorNum}개 성공 ${this.errorNum}개 실패하였습니다.`
      this.createAlert({
        content: msg,
        hide: () => {
          EventBus.$emit('apiLoading', false);
          this.initData()
          this.$router.push('/item/list');
        }
      });
    },
    initData() {
      this.files = []
      this.zipFiles = []
      this.imageArr = []
      this.selectMember = {}
      this.category = ''
      this.collection = ''
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
